export const ERR_EMPTY = "入力してください";
export const ERR_BAD_FORMAT = "正しい形式で入力してください";
export const ERR_POSTCODE_NOT_FOUND = "住所が存在しないようです";
export const ERR_POST_POSTCODE_FAILED = "郵便番号の存在が確認できませんでした。このまま保存しますか？";
export const ERR_EMPTY_SELECTION = "選択してください";
export const ERR_BAD_OLD_PASSWORD_FORMAT = "6文字以上で入力してください";
export const ERR_BAD_KANA_FORMAT = "全角カタカナで入力してください";
export const ERR_BAD_PASSWORD_FORMAT = "8文字以上で入力してください";
export const ERR_BAD_PASSWORD_FORMAT_INVALID = "半角英小文字、半角英大文字、半角数字をそれぞれ1文字以上含めてください。";
export const ERR_BAD_PASSWORD_USE_NEW_PW = "使用したことがないパスワードを作成してください";
export const ERR_BAD_HOUJIN_NUMBER_FORMAT = "法人番号は13桁の半角数字で入力してください";
export const ERR_SIGN_UP_EMAIL_EXISTS = "すでに登録されているアドレスです";
export const ERR_LOG_IN_INVALID = "アドレス・パスワードのいずれかが間違っています";
export const ERR_REQUEST_PASSWORD_EMAIL_NOT_FOUND = "該当するメールアドレスが見つかりませんでした"
export const ERR_PASSWORD_NOT_MATCHED = "パスワードがマッチしていません";
export const ERR_FILE_TYPE_NOT_ACCEPTED = "アップロードできる拡張子は、.jpg、.png、.gif、.svgのみです";
export const ERR_SAVE_FAILURE = "保存に失敗しました。恐れ入りますが、もう一度お試しください。";
export const ERR_GET_FAILURE = "取得に失敗しました。恐れ入りますが、もう一度お試しください。";
export const ERR_ORDER_FAILURE = "注文に失敗しました。恐れ入りますが、もう一度お試しください。";
// タイムアウト・通信断の場合はサーバー側で注文が成立している可能性があるため、そのまま再注文させない
export const ERR_ORDER_TIMEOUT = "注文処理が制限時間内に完了しませんでした。注文が完了している可能性がありますので、注文履歴をご確認のうえ、重複注文にご注意ください。";
export const ERR_ORDER_NETWORK = "通信エラーにより注文結果を確認できませんでした。注文が完了している可能性がありますので、注文履歴をご確認のうえ、重複注文にご注意ください。";
export const ERR_REGIST_FAILURE = "登録に失敗しました。ブラウザを再読み込みしてもう一度お試しください。";
export const ERR_REMOVE_FAILURE = "削除に失敗しました。恐れ入りますが、もう一度お試しください。";
export const ERR_REMOVE_ORDERED_ITEM = "注文済みまたはテスト配送済みのアイテムは削除することができません。";
export const ERR_APPLY_SAAS_KEY = "プロダクトキーに誤りがあります";
export const ERR_EDIT_FAILURE = "編集に失敗しました。恐れ入りますが、もう一度お試しください。";
export const ERR_COPY_FAILURE = "複製に失敗しました。恐れ入りますが、もう一度お試しください。";
export const ERR_ADDRESS = "住所は都道府県から入力してください。";
export const ERR_CONTAINS_SYMBOL = "記号が含まれている項目を確認してください。";
export const ERR_DOWNLOAD_FAILURE = "ダウンロードに失敗しました。恐れ入りますが、もう一度お試しください。";
export const ERR_MOVE_NG_SENDINGS_NO_CORPORATE_NUM = "法人番号が設定されていないため送付NGリストに移動できません。"
export const ERR_RESTORE_NG_SENDINGS = "取り消しに失敗しました。"
export const ERR_VERIFY = "照合に失敗しました。恐れ入りますが、もう一度お試しください。"
export const ERR_UPDATE = "更新に失敗しました。恐れ入りますが、もう一度お試しください。"
export const ERR_EMPTY_UPLOAD_FILE = "内容物をアップロードしてください。";
export const ERR_EMPTY_ORDER_CONTACT = "注文担当者を選択してください。";
export const ERR_EMPTY_SENDER = "差出人を選択してください。";
export const ERR_EMPTY_TRACKING_URL = "QRコードのURLを入力してください。";
export const ERR_BAD_FORMAT_TRACKING_URL = "QRコードのURLを正しい形式で入力してください。";
export const ERR_MAX_TRACKING_URL_LENGTH = "QRコードのURLは1024文字以下で入力してください。";
export const ERR_MAILING_TO = "宛先に不正があります。";
export const ERR_MAX_LETTER_NUM_REACHED = "送付通数の上限に達しています。";
export const ERR_GET_SALESFORCE_PREVIEW_FAILURE = "プレビューの取得に失敗しました。恐れ入りますが、もう一度お試しください。";
export const ERR_GET_SALESFORCE_DESCRIBE_FAILURE = "Salesforce項目の取得に失敗しました。恐れ入りますが、もう一度お試しください。";
export const ERR_POST_SALESFORCE_SYNC_FAILURE = "同期に失敗しました。";
export const ERR_POST_SALESFORCE_REVOKE_FAILURE = "連携解除に失敗しました。";
export const ERR_GET_SALESFORCE_LISTVIEWS_FAILURE = "リストビューの取得に失敗しました。恐れ入りますが、もう一度お試しください。";
export const ERR_POST_SALESFORCE_CONFIG_FAILURE = "同期設定の保存に失敗しました。恐れ入りますが、もう一度お試しください。";
export const ERR_READ_FILE = "ファイルの読み取りに失敗しました。エクセルがパスワードで保護されている、または破損している可能性があります。";



// WEBPACK FOOTER //
// ./src/constants/ErrorMessages.js